import React, { useState, useEffect, useRef } from 'react';
import { useParams, useLocation, Link, useNavigate } from 'react-router-dom';
import html2canvas from 'html2canvas';
import download from 'downloadjs';
import Flag1 from '../color-templates/flag-1';
import Flag4 from '../color-templates/Flag4';
import Flag5 from '../color-templates/Flag5';
import Flag6 from '../color-templates/Flag6';
import Flag7 from '../color-templates/Flag7';
import Flag9 from '../color-templates/Flag9';
import Temp7 from '../color-templates/Temp7';
import Temp8 from '../color-templates/Temp8';
import Temp9 from '../color-templates/Temp9';
import "./../styles/colorbook.css";
import GameNav from '../GameNav'
import cbcolors from '../CBcolors';


function ColoringBook() {

    const navigate = useNavigate();

    const [colorMenu, showColorMenu] = useState(false);

    const coloringBookRef = useRef(null);

    const [activeZoom, setActiveZoom] = useState(false);

    const [zoomLevel, setZoomLevel] = useState(1);

    const [notification, setNotification] = useState(false);

    const [instructions, setInstructions] = useState(true);

    const hideInstructions = () => {
        setInstructions(false);
    }


    const toggleNotification = () => {
        setNotification(!notification);
    }





    const toggleZoom = () => {
        setActiveZoom(!activeZoom)
    }


    const toggleColorMenu = () => {
        showColorMenu(!colorMenu);
    }
    //make custom confirm element
    const handleBackClick = () => {
        navigate("/coloringbookoptions");
    }


    const handleZoomClick = (event) => {
        if (activeZoom && coloringBookRef.current) {
            const rect = coloringBookRef.current.getBoundingClientRect();
            const x = (event.clientX - rect.left) / rect.width;
            const y = (event.clientY - rect.top) / rect.height;

            setZoomLevel(zoomLevel + 0.1);

            const container = coloringBookRef.current;
            const deltaX = container.clientWidth * 0.1 * x;
            const deltaY = container.clientHeight * 0.1 * y;

            container.style.transformOrigin = `${x * 100}% ${y * 100}%`;
            container.style.transform = `scale(${zoomLevel})`;
            container.scrollLeft = deltaX;
            container.scrollTop = deltaY;
        }
    };

    const resetZoom = () => {

        if (activeZoom === true) {
            setZoomLevel(1)
            toggleZoom();
        }
        setZoomLevel(1)
    }





    const handleSaveClick = () => {
        resetZoom();
        if (coloringBookRef.current) {
            html2canvas(coloringBookRef.current, {
                useCORS: true,
                backgroundColor: null,
                // scale: window.devicePixelRatio || 1,
                scale: window.devicePixelRatio || 2,
            })
                .then((canvas) => {
                    const imageDataURL = canvas.toDataURL('image/png');
                    const userAgent = navigator.userAgent;

                    // Detect if using an in-app browser (Google app or other)
                    const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
                    const isInAppBrowser = !/Chrome|Safari/.test(userAgent);

                    if (isIOS) {
                        if (isInAppBrowser) {
                            // Handle in-app browser like the Google app
                            alert('In-app browsers like the Google app may not support direct downloads. Please use Safari or another browser to save the image.');
                        } else {
                            // Handle Safari or Chrome
                            const link = document.createElement('a');
                            link.href = imageDataURL;
                            link.download = 'coloring_book.png';
                            link.style.display = 'none';
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                        }
                    } else {
                        // Non-iOS platforms
                        download(imageDataURL, 'coloring_book.png', 'image/png');
                    }
                })
                .catch((error) => {
                    console.error("Error generating canvas:", error);
                });
        }
    };






    const { id } = useParams();
    const location = useLocation();
    const selectedTemplate = location.state.selectedTemplate;
    const [selectedColor, setSelectedColor] = useState(1);
    const [menu, setMenu] = useState(1);
    const [stroke, setStrokeValue] = useState(21);

    const [selectedStroke, setStroke] = useState('black');


    const displayFillMenu = () => {
        setMenu(1)

    }

    const displayStrokeMenu = () => {
        setMenu(2);

    }

    const selectColorClick = (id) => {
        if (activeZoom === true) {
            toggleZoom();
        }
        setSelectedColor(id)
    }

    const changeStrokeValue = (id) => {
        if (menu === 2) {
            setStrokeValue(id);
        }
    };

    const changeStrokeClick = (id) => {
        if (menu === 2) {
            const selectedHexColor = cbcolors.find((color) => color.id === id)?.color;
            if (selectedHexColor) {
                setStroke(selectedHexColor);
                changeStrokeValue(id);
            }
        }
    };


    const topStrokeIcon = () => {
        if (!colorMenu) {
            toggleColorMenu();
            setMenu(2);
        } else {
            setMenu(2);
        }
    }

    const topFillIcon = () => {
        if (!colorMenu) {
            toggleColorMenu();
            setMenu(1);
        } else {
            setMenu(1);
        }
    }


    function getColorById(id) {
        const selectedHexColor = cbcolors.find((color) => color.id === id)?.color;
        return selectedHexColor || 'defaultColor';
    }





    const onPathClick = (event) => {

        if (!activeZoom) {


            if (
                event.target.tagName === 'path' ||
                event.target.tagName === 'polyline' ||
                event.target.tagName === 'polygon' ||
                event.target.tagName === 'circle' ||
                event.target.tagName === 'rect'
            ) {
                const element = event.target;
                const id = selectedColor;
                const selectedHexColor = cbcolors.find((color) => color.id === id)?.color;


                if (selectedHexColor) {
                    element.setAttribute('fill', selectedHexColor);
                }
            }


            if (event.target.classList.contains('grp')) {
                const id = selectedColor;
                const selectedHexColor = cbcolors.find((color) => color.id === id)?.color;


                if (selectedHexColor) {
                    const groupElements = document.querySelectorAll('.grp');
                    groupElements.forEach((groupElement) => {
                        groupElement.setAttribute('fill', selectedHexColor);
                    });
                }
            }

            if (event.target.classList.contains('stereo')) {
                const id = selectedColor;
                const selectedHexColor = cbcolors.find((color) => color.id === id)?.color;


                if (selectedHexColor) {
                    const groupElements = document.querySelectorAll('.stereo');
                    groupElements.forEach((groupElement) => {
                        groupElement.setAttribute('fill', selectedHexColor);
                    });
                }
            }


        }

    };



    const selectedFlag = {
        1: <Flag1 key={1} selectedColor={selectedColor} selectedStroke={selectedStroke} onPathClick={onPathClick} />,
        2: <Flag4 key={2} selectedColor={selectedColor} selectedStroke={selectedStroke} onPathClick={onPathClick} />,
        3: <Flag5 key={3} selectedColor={selectedColor} selectedStroke={selectedStroke} onPathClick={onPathClick} />,
        4: <Flag6 key={4} selectedColor={selectedColor} selectedStroke={selectedStroke} onPathClick={onPathClick} />,
        5: <Flag7 key={5} selectedColor={selectedColor} selectedStroke={selectedStroke} onPathClick={onPathClick} />,
        6: <Flag9 key={6} selectedColor={selectedColor} selectedStroke={selectedStroke} onPathClick={onPathClick} />,
        7: <Temp7 key={7} selectedColor={selectedColor} selectedStroke={selectedStroke} onPathClick={onPathClick} />,
        8: <Temp8 key={8} selectedColor={selectedColor} selectedStroke={selectedStroke} onPathClick={onPathClick} />,
        9: <Temp9 key={9} selectedColor={selectedColor} selectedStroke={selectedStroke} onPathClick={onPathClick} />

    }[id];



    return (
        <div id='coloring-book-main'>

            <GameNav />

            <div className='cbgn'>

                <div id="cb-functions">






                    <div className='top-c-icons-container'>
                        <div className='top-c-icons' style={{ backgroundColor: getColorById(selectedColor) }}
                            onClick={topFillIcon}
                        >

                        </div>


                        <div className='top-c-icons' style={{ backgroundColor: `${selectedStroke}`, display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                            onClick={topStrokeIcon}
                        >
                            <div style={{ width: '40%', height: '40%', backgroundColor: 'white' }}></div>
                        </div>
                    </div>





                    <div className='zoom-btns-container'>
                        <div className={`zoom-btn ${activeZoom ? 'zoom-btn-active' : ''}`} onClick={() => setActiveZoom(!activeZoom)}>
                            <img src={process.env.PUBLIC_URL + '/images/zoom-in.png'} height='20px'></img>
                        </div>
                        <div className='zoom-btn' onClick={resetZoom}>
                            <img src={process.env.PUBLIC_URL + '/images/zoom-out.png'} height='20px'></img>
                        </div>
                    </div>



                    <div onClick={handleSaveClick} className='save-share-btn'>
                        <img src={process.env.PUBLIC_URL + '/images/download-icon.png'} height='17px'></img>
                    </div>


                </div>
            </div>







            {!instructions ? (
                <></>
            ) : (
                <div id='coloring-book-instrutions'>
                    <div id='instructions-background'>
                    </div>
                    <div id='instructions-content'>
                        <h2>Coloring Book</h2>
                        <p>Welcome to our coloring book. To get started, click on the paint pallete icon in the bottom left corner to open the color menu. Once there, either select fill or outline. Select a color, then close the menu to begin coloring. Click the zoom button to zoom in to color smaller areas. Then click the zoom out button to reset. It is reccomended to use Google Chrome or Safari, other in app browsers may not support the ability to save images to your device. </p>
                        <button onClick={hideInstructions}>Get Started</button>
                    </div>
                </div>
            )}
            {/* i gave this overflow hidden before but think i don't need it */}
            <div className={`flag-container-outer ${instructions ? 'cloring-book-blur' : ''}`} >
                <div ref={coloringBookRef} className={`flag-container ${activeZoom ? 'zoom-cursor' : 'paint-cursor'}`} style={{ transform: `scale(${zoomLevel})` }} onClick={handleZoomClick}>
                    {selectedFlag}
                </div>
            </div>



            {colorMenu ? (
                <div id='color-control' className={`${instructions ? 'cloring-book-blur' : ''}`}>
                    <div className='fill-stroke'>
                        <div className={`fill-tab ${menu === 1 ? 'active-fill-tab' : ''}`} onClick={displayFillMenu}>
                            <p>Fill</p>
                            <div style={{ backgroundColor: getColorById(selectedColor), width: '15px', height: '15px', border: '1px solid white' }}></div>
                        </div>

                        <div className={`stroke-tab ${menu === 2 ? 'active-fill-tab' : ''}`} onClick={displayStrokeMenu}>
                            <p>Outline</p>

                            <div style={{ backgroundColor: `${selectedStroke}`, border: '1px solid white', width: '15px', height: '15px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <div style={{ width: '40%', height: '40%', backgroundColor: 'white' }}></div>
                            </div>

                        </div>
                        <div className='exit-colors' onClick={toggleColorMenu}>
                            <svg className='cxo' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 105.55 105.56">
                                <path className='cx' d="M250.1,360.72a9.14,9.14,0,0,1,0,12.93l-5.45,5.45a9.14,9.14,0,0,1-12.93,0L200,347.38,168.28,379.1a9.14,9.14,0,0,1-12.93,0l-5.45-5.45a9.14,9.14,0,0,1,0-12.93L181.62,329,149.9,297.28a9.14,9.14,0,0,1,0-12.93l5.45-5.45a9.14,9.14,0,0,1,12.93,0L200,310.62l31.72-31.72a9.14,9.14,0,0,1,12.93,0l5.45,5.45a9.14,9.14,0,0,1,0,12.93L218.38,329Z" transform="translate(-147.22 -276.22)" />
                            </svg>

                        </div>
                    </div>

                    <div id='color-pallete'>


                        {cbcolors.map((color) => (


                            <div className={`color-container ${menu === 1 && color.id === selectedColor ? 'active-color' : ''} ${menu === 2 && color.id === stroke ? 'selected-stroke-color' : ''}`}>


                                <div
                                    className='color'
                                    key={color.id}
                                    color={color}
                                    style={{ backgroundColor: `${color.color}` }}
                                    // onClick={() => selectColorClick(color.id)}
                                    onClick={() => (menu === 1 ? selectColorClick(color.id) : changeStrokeClick(color.id))}
                                >

                                    {menu === 2 ? (
                                        <div className='stroke-center' > </div>
                                    ) : (
                                        <></>
                                    )}
                                </div>


                            </div>

                        ))}

                    </div>
                </div>
            ) : (
                <> </>
            )

            }




            {notification &&
                <div id="goback-notification">
                    <h3>Are You Sure?</h3>
                    <p>Are you sure you want to choose a new template? All of your work will be lost. If you are pleased with your artwork, you can save it to your device before exiting. </p>

                    <div id='noty-btns'>
                        <button onClick={handleBackClick} className='noty-btn'>OK</button>
                        <button onClick={toggleNotification} className='noty-btn'>Cancel</button>
                    </div>
                </div>}





            <div id='new-temp-parent1' className='new-temp-parent'>


                <div onClick={toggleNotification} className='new-temp'>
                    <svg className='back-arrow' data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 211.74 170.66">
                        <path className='back-arrow-path' d="M967,236.55a11.13,11.13,0,0,1-11.12,11.12H804.46l47.24,38.05,18.47,14.87a12,12,0,0,1-7.56,21.29,11.75,11.75,0,0,1-7.44-2.67l-41.59-33.49L757,240.11a4.57,4.57,0,0,1,0-7.12l56.62-45.61,41.59-33.49a12,12,0,0,1,15,18.62L851.7,187.38l-47.24,38.05H955.88A11.12,11.12,0,0,1,967,236.55Z" transform="translate(-755.26 -151.22)" />
                    </svg>
                </div>

            </div>




            <svg onClick={toggleColorMenu} className='color-pallete-icon' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 422.33 423.38">
                <path d="M567,446C555.07,340,464.73,257.61,355.3,258.31A211.25,211.25,0,0,0,145,470c0,116.91,94.78,211.69,211.69,211.69C415.87,666.37,380.5,621,380.5,621s-18.5-46.5,24-57c127.29,14.7,155.88-73.73,161.77-102.37A49.84,49.84,0,0,0,567,446ZM223.15,476a37.5,37.5,0,1,1,37.5-37.5A37.5,37.5,0,0,1,223.15,476Zm68-89a37.5,37.5,0,1,1,37.5-37.5A37.5,37.5,0,0,1,291.15,387ZM409,387a37.5,37.5,0,1,1,37.5-37.5A37.5,37.5,0,0,1,409,387Zm70,89a37.5,37.5,0,1,1,37.5-37.5A37.5,37.5,0,0,1,479,476Z" transform="translate(-145 -258.31)" />
            </svg>



        </div >
    );
}

export default ColoringBook;
